module.exports = __webpack_public_path__ + "img/dice-4.092563d3.png";